<template>
  <svg class="icon"
       width="20"
       height="20"
       viewBox="0 0 20 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M16.2536 -0.00292969C15.2942 -0.00292969 14.3357 0.36269 13.6044 1.09317C9.41463 5.28297 5.22483 9.47277 1.03483 13.6628L6.33643 18.9644C10.5262 14.7746 14.716 10.5848 18.906 6.39477C20.3677 4.93305 20.3638 2.55417 18.9029 1.09317C18.1724 0.36271 17.2131 -0.00292969 16.2537 -0.00292969H16.2536ZM0.384826 14.7807L0.00122558 19.3229C-0.0308064 19.7088 0.291066 20.0307 0.676226 19.9979L5.21603 19.6127L0.384826 14.7807Z" />
  </svg>
</template>

<script>
export default {
  name: 'Edit',
};
</script>
